import { useEffect, useCallback } from 'react';
import { usePlaid, usePersonalLoanRouteFsm, useAch } from 'shared/hooks';

const PlaidOAuthSuccess = () => {
  const { loaded, reinitialize } = usePlaid();
  const { savePlaidAuthLink } = useAch();
  const runRouter = usePersonalLoanRouteFsm();

  const uuid = localStorage.getItem('personalLoan_uuid');

  const onSuccess = useCallback(
    async (accessToken, metadata) => {
      await savePlaidAuthLink(accessToken, metadata);

      runRouter(uuid);
    },
    [savePlaidAuthLink, runRouter, uuid]
  );

  useEffect(() => {
    if (uuid && loaded) {
      reinitialize({
        onSuccess,
        onExit: () => runRouter(uuid),
      });
    }
  }, [uuid, loaded, runRouter, reinitialize, onSuccess]);

  return null;
};

export default PlaidOAuthSuccess;
